import script from "./live-events-card.vue?vue&type=script&setup=true&lang=js"
export * from "./live-events-card.vue?vue&type=script&setup=true&lang=js"

import "./live-events-card.vue?vue&type=style&index=0&id=7da64ffe&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da64ffe"]])

export default __exports__